import React from "react";
import loader from "../../components/loader/loader";

const ViewItems = ({ viewDetails, modalId }) => {
  const ViewData = viewDetails ? viewDetails : "";
  const getBadge = (status) => {
    switch (status) {
      case "active":
        return "success";
      case "inactive":
        return "secondary";
      case "busy":
        return "warning";
      default:
        return "primary";
    }
  };
  return (
    <React.Fragment>
      <div
        className="modal fade"
        id={modalId}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
                {viewDetails && ViewData?.id ? (
                  <form
                    id="kt_modal_new_target_form"
                    className="form fv-plugins-bootstrap5 fv-plugins-framework"
                    action="#"
                  >
                    <div className="mb-8 text-center">
                      <h1 className="mb-3 text-primary">Checklist Detail</h1>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Name</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {ViewData?.name}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Parent Name</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {ViewData?.parentName}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Details</span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold">
                        {ViewData?.details}
                      </div>
                    </div>
                    {/* <div className="row mb-5">
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Status</span>
                      </label>
                      <div className="text-gray-400 fs-4 fw-bold text-capitalize">
                        <span
                          className={`btn ${getBadge(
                            ViewData?.status
                          )} text-capitalize`}
                        >
                          {ViewData?.status}
                        </span>
                      </div>
                    </div>
                  </div> */}
                    <div></div>
                  </form>
                ) : (
                  loader()
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ViewItems;
